import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c3e3919e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "font-picker" }
const _hoisted_2 = ["onClick"]

import { ref } from "vue";

import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "FooterView",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    fonts: {},
    currentFont: {}
  },
  emits: ["updated-font"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;
const changeFont = (newFont: string) => {
  emit("updated-font", newFont);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.fonts, (font) => {
      return (_openBlock(), _createElementBlock("div", {
        key: font,
        class: "font-button-container"
      }, [
        _createElementVNode("button", {
          class: "font-button",
          onClick: ($event: any) => (changeFont(font))
        }, [
          _createElementVNode("p", {
            style: _normalizeStyle({ fontFamily: props.currentFont })
          }, _toDisplayString(font), 5)
        ], 8, _hoisted_2)
      ]))
    }), 128))
  ]))
}
}

})